import React from 'react';
import  "./photo.css"

function Photo() {
    return (
      <div className="photobody">
        <div className="photodiv">
          <img src="/rajnarayana.png" />
        </div>
      </div>
    );
}

export default Photo
